import clsx from "clsx";
import { CSSProperties, FunctionComponent, MouseEventHandler } from "react";

import * as styles from "./Link.css";

interface Props {
  className?: string;
  anchorClassName?: string;
  contentClassName?: string;
  special?: boolean;
  showLinkLines?: boolean;
  icon?: React.ReactElement;
  variant: "standard" | "homepage";
  href?: string;
  style?: CSSProperties;
  children?: React.ReactNode;
  onClick?: MouseEventHandler;
  monochrome?: boolean;
}

const Link: FunctionComponent<Props> = ({
  className,
  anchorClassName,
  contentClassName,
  special,
  children,
  style,
  showLinkLines,
  icon,
  variant,
  monochrome,
  ...props
}) => {
  const Clickable = props.href ? "a" : "button";
  return (
    <li
      className={clsx(
        className,
        styles.container,
        showLinkLines && styles.withLines[variant],
      )}
    >
      <Clickable {...props} className={clsx(anchorClassName, styles.anchor)}>
        <span
          className={clsx(
            styles.contentMargin[variant],
            styles.content[special ? "special" : "regular"],
            monochrome && styles.monochrome,
            contentClassName,
          )}
          style={style}
        >
          {children}
          {icon && <span className={styles.icon}>{icon}</span>}
        </span>
      </Clickable>
    </li>
  );
};

export default Link;
